(function () {
    'use strict';

    angular
        .module('app.cookies')
        .run(configureRoutes);

    function configureRoutes(routeManager) {
        routeManager.addStates([
            {
                state: 'cookies',
                config: {
                    templateUrl: 'app/basicPages/cookies/cookies.html',
                    url: '/cookies'
                }
            }
        ]);
    }
})();